module.exports = __webpack_public_path__ + "img/mega.f203e93b.jpg";